import { mapState } from "vuex";
export const goodsIndexMixins = {
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
    goodsTopBarList() {
      let topbarList = [
        {
          name: "商品管理",
          isActive: false,
          path: "/goods",
          childrenPath: ["/goods/edit"],
          icon:require("@/assets/img/menuIcons/icon-goods.png")
        },
        {
          name: "分类管理",
          isActive: false,
          path: "/goods/tag",
          childrenPath: ["/goods/tag/secondary"],
          icon:require("@/assets/img/menuIcons/icon-goodstag.png")
        },
      ];
      if (this.shopInfo.edcShopType == 4) {
        topbarList.push({
          name: "单位管理",
          isActive: false,
          path: "/goods/unit",
          icon:require("@/assets/img/menuIcons/icon-goodsunit.png")
        });
      }
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
        if (val.childrenPath) {
          if (~val.childrenPath.indexOf(this.$route.path)) {
            val.isActive = true;
          }
        }
      });
      return topbarList;
    },
  },
}
